import { Button, CircularProgress, Grid } from '@mui/material';
import VehicleCard from 'components/molecules/VehicleCard';
import HeaderAndSidebar from 'components/templates/HeaderAndSidebar';
import { Vehicle } from 'types';

type Props = {
  isLoading: boolean;
  vehicles: Vehicle[];
  onClickNew: () => void;
  onClickEdit: (vehicle: Vehicle) => void;
  onClickDelete: (vehicle: Vehicle) => void;
};

const Vehicles: React.FC<Props> = ({
  isLoading,
  vehicles,
  onClickNew,
  onClickEdit,
  onClickDelete,
}) => (
  <HeaderAndSidebar pageTitle="燃費計算">
    {isLoading ? (
      <CircularProgress />
    ) : (
      <Grid item xs={12} md={12} lg={12}>
        <Grid item>
          <Button variant="contained" color="primary" onClick={onClickNew}>
            追加
          </Button>
        </Grid>
        <Grid container>
          {vehicles.map((vehicle) => (
            <VehicleCard
              key={vehicle.id}
              vehicle={vehicle}
              onClickEdit={onClickEdit}
              onClickDelete={onClickDelete}
            />
          ))}
        </Grid>
      </Grid>
    )}
  </HeaderAndSidebar>
);

export default Vehicles;
